(function () {

let chat = document.querySelector('.chat-container');
if(!chat) return;



let saved = null;

saved = localStorage.getItem('nova_chat_id');

const urlParams = new URLSearchParams(window.location.search);
const id = urlParams.get('chat_thread_id');
if(id){
  saved = id;
}




if(saved){
    fetch('https://api.ddhammocks.com/chat/history/' + saved, {
        method: 'GET', cache: 'no-cache',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
        }
    })
    .then(function(response){
        if(!response.ok){
            throw new Error('Network response was not ok');
        }
        return response.json();
    }).then(function(json){
        if(json.success){
            document.querySelector('.chat').dataset.chat_id = saved;
            json.data.forEach(function(msg){
                clone = document.getElementById('message-template').content.cloneNode(true);
                clone.querySelector('.chat__message').classList.add('chat__message--' + msg.role);
                clone.querySelector('.chat__message').innerHTML = msg.content;
                document.querySelector('.chat-convo').appendChild(clone);
            });
            c = document.querySelector('.chat-convo');
            c.scrollTo({top: c.scrollHeight, behavior: 'smooth'});
        }
    }).catch(function(ex){
        
    });
}

document.querySelector('.chat__options-toggle').addEventListener('click', function(ev){
    ev.preventDefault();
    document.querySelector('.chat__options-menu').classList.toggle('hide');
});

document.querySelector('.chat__clear').addEventListener('click', function(ev){
    ev.preventDefault();
    document.querySelector('.chat-convo').innerHTML = '';
    document.querySelector('.chat').dataset.chat_id = '';
    localStorage.removeItem('nova_chat_id');
    document.querySelector('.chat__options-menu').classList.add('hide');
});


function sendChat(ev){
    chat = document.querySelector('.chat')

    content = document.querySelector('.chat__input').value.trim();
    if(!content){
        return;
    }

    document.querySelector('.chat__send').disabled = true;

    c = document.querySelector('.chat-convo');

    data = JSON.stringify({chat_id: chat.dataset.chat_id, query: content});

    clone = document.getElementById('message-template').content.cloneNode(true);
    clone.querySelector('.chat__message').classList.add('chat__message--user');
    clone.querySelector('.chat__message').innerHTML = content;
    document.querySelector('.chat-convo').appendChild(clone);

    

    document.querySelector('.chat__input').value = '';

    res = document.getElementById('message-template').content.cloneNode(true);

    res = res.querySelector('.chat__message');
    res.classList.add('chat__message--assistant');
    res.innerHTML = 'Loading...';

    document.querySelector('.chat-convo').appendChild(res);


    c.scrollTo({top: c.scrollHeight, behavior: 'smooth'});


    const handle = FESStandalone.startEventStream('https://api.ddhammocks.com/webchat/stream', {
        method: 'POST',
        cache: 'no-cache',
        headers: {
            'Content-Type': 'application/json',
        },
        body: data,

        onopen(resp){
            const ct = resp.headers.get('content-type') || '';
            if (!resp.ok || !/text\/event-stream/i.test(ct)) {
                handle.close();
                res.remove();
                document.querySelector('.chat__send').disabled = false;
            }
        },

        onmessage(ev){
            if(ev.event == 'chat_id'){
                chat.dataset.chat_id = ev.data;
                localStorage.setItem("nova_chat_id", ev.data);
                res.innerHTML = '';
            }
            if(ev.event == 'message'){
                res.insertAdjacentText('beforeend', ev.data);
                c.scrollTo({top: c.scrollHeight, behavior: 'smooth'});
            }
            if(ev.data === '[DONE]' || ev.event === 'end'){
                handle.close();
                res.innerHTML = marked.parse(res.innerHTML);
                res.classList.remove('chat__message--in-progress');
                c.scrollTo({top: c.scrollHeight, behavior: 'smooth'});
            }
        },

        onclose(){
            handle.close();
            document.querySelector('.chat__send').disabled = false;
        },

        onerror(err){
            handle.close();
            res.remove();
            document.querySelector('.chat__send').disabled = false;
        }
    });

}
document.querySelector('.chat__send').addEventListener('click', sendChat);

document.querySelector('.chat__input').addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        sendChat();
    }
});


})();